import script from "./GroupCreateDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupCreateDialog.vue?vue&type=script&lang=ts&setup=true"

import "./GroupCreateDialog.vue?vue&type=style&index=0&id=4e8a7b63&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e8a7b63"]])

export default __exports__